import './CallToAction.css'
import React from 'react'

import Content from './Content'
import Link from './Link'

export default ({ title, content, buttonText, buttonUrl, image }) =>
    <section className='call-to-action section-image' style={{backgroundImage: `url(${image.publicURL})`}} >
        <div className='container container-small'>
            {title && <h2>{title}</h2>}
            {content && <Content src={content} />}
            {buttonText && buttonUrl && <Link className='button' to={buttonUrl}>{buttonText}</Link>}
        </div>
    </section>


// WEBPACK FOOTER //
// ./src/components/CallToAction.js